module.exports = __webpack_public_path__ + "87f58d8285bab5736dc6cbd46c4a436b.MP3";